import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useAllUsers } from "../../../services/queries/queries";

// Lets an admin build a list of target user uuids by searching for people by
// email instead of pasting raw uuids - the picker only needs to know each
// selected person's uuid + email to render a chip; the uuid is still what
// actually gets sent to the backend.
const UserSearchMultiSelect = ({ selected, onChange }) => {
  const [search, setSearch] = useState("");
  const [debounced, setDebounced] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(search), 300);
    return () => clearTimeout(timeout);
  }, [search]);

  const { data, isFetching } = useAllUsers(1, 10, debounced);
  const results = (data?.data || []).filter(
    (u) => !selected.some((s) => s.uuid === u.uuid),
  );

  const addUser = (user) => {
    onChange([...selected, { uuid: user.uuid, email: user.email }]);
    setSearch("");
  };

  const removeUser = (uuid) => onChange(selected.filter((u) => u.uuid !== uuid));

  return (
    <div className="space-y-2">
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {selected.map((u) => (
            <span
              key={u.uuid}
              className="inline-flex gap-1.5 items-center px-2.5 py-1 text-xs font-medium text-emerald-800 bg-emerald-100 rounded-full"
            >
              {u.email}
              <button
                type="button"
                onClick={() => removeUser(u.uuid)}
                className="text-emerald-600 hover:text-emerald-900"
              >
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="relative">
        <input
          type="text"
          placeholder="Search by email to add a user"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="px-3 py-2.5 w-full text-sm rounded-lg border border-gray-200 outline-none focus:ring-2 focus:ring-emerald-500"
        />
        {debounced && (
          <div className="overflow-auto absolute z-50 mt-1 w-full max-h-48 bg-white rounded-lg border border-gray-200 shadow-lg">
            {isFetching && (
              <div className="px-3 py-2 text-xs text-gray-400">Searching...</div>
            )}
            {!isFetching && results.length === 0 && (
              <div className="px-3 py-2 text-xs text-gray-400">No matching users</div>
            )}
            {results.map((u) => (
              <button
                type="button"
                key={u.uuid}
                onClick={() => addUser(u)}
                className="block px-3 py-2 w-full text-sm text-left text-gray-700 hover:bg-gray-50"
              >
                {u.email}
                <span className="ml-2 text-xs text-gray-400">
                  {u.firstName} {u.lastName}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserSearchMultiSelect;
